import Dialog from '../common/Dialog'
import Button from '../common/Button'
import LoadingSpinner from '../common/LoadingSpinner'
import WebsiteConnectionCreateForm from './WebsiteConnectionCreateForm'
import WebsiteConnectionUpdateForm from './WebsiteConnectionUpdateForm'

const WebsiteConnectionDialog = ({
  isOpen,
  onClose,
  isEditMode,
  isCreating,
  isUpdating,
  // Create form props
  createFormRegister,
  createFormErrors,
  selectedCreatePlatform,
  handleCreateSubmit,
  // Update form props
  updateFormRegister,
  updateFormErrors,
  selectedUpdatePlatform,
  handleUpdateSubmit,
}) => {
  const isLoading = isCreating || isUpdating

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={isEditMode ? 'Edit Website Connection' : 'Add Website Connection'}
      size="lg"
      footer={
        <div className="flex gap-3">
          <Button variant="secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={isEditMode ? handleUpdateSubmit : handleCreateSubmit}
            icon={isEditMode ? 'mdi:content-save' : 'mdi:plus'}
            disabled={isLoading}
          >
            {isEditMode ? (
              isUpdating ? (
                <>
                  <LoadingSpinner size="sm" />
                  Updating...
                </>
              ) : (
                'Update'
              )
            ) : isCreating ? (
              <>
                <LoadingSpinner size="sm" />
                Creating...
              </>
            ) : (
              'Create'
            )}
          </Button>
        </div>
      }
    >
      {isEditMode ? (
        <WebsiteConnectionUpdateForm
          register={updateFormRegister}
          errors={updateFormErrors}
          selectedPlatform={selectedUpdatePlatform}
        />
      ) : (
        <WebsiteConnectionCreateForm
          register={createFormRegister}
          errors={createFormErrors}
          selectedPlatform={selectedCreatePlatform}
        />
      )}
    </Dialog>
  )
}

export default WebsiteConnectionDialog
